import React, { createContext, useContext, useState } from "react";
import { spinnerService } from "@chevtek/react-spinners";

import { useGetCategories } from "../../hooks/api/wc/useGetCategories";
import { useGetProducts } from "../../hooks/api/wc/useGetProducts";

// Create a new context
export const ProductsContext = createContext();

export const useProductsContext = () => useContext(ProductsContext);

// Create a provider component
export const ProductsProvider = ({ children }) => {
  const categoriesHook = useGetCategories({ per_page: 100 });
  const productsHook = useGetProducts();

  const categories = categoriesHook.isLoading ? [] : categoriesHook.data;
  const products = productsHook.isLoading ? [] : productsHook.data?.list;

  if (categoriesHook.isLoading || productsHook.isLoading) {
    spinnerService.show("ug");
  } else if (categoriesHook.isFetched && productsHook.isFetched) {
    spinnerService.hide("ug");
  }
  return (
    <ProductsContext.Provider
      value={{
        categories,
        isLoadingProducts: productsHook.isLoading,
        products,
        totalPages: productsHook.data?.totalPages,
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

export default ProductsContext;
